import axios from '../axios'

// モジュール教材の更新（名前・リンク）
const putModuleMaterialApi = async (materialId, payload) => {
  return await axios.put(`api/lms/module-materials/${materialId}`, payload)
}

export default putModuleMaterialApi
